import React from 'react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import Page from '../components/Page'
import { Section, Container } from '../components/common'

export default () => (
  <Page>
    <Section thick>
      <Container taCenter>
        <h1>404 – Page Not Found</h1>
        <p>The page <strong>{window.location.pathname}</strong> cannot be found.</p>
        <p>Please return to our <Link to='/'>homepage</Link>.</p>
      </Container>
    </Section>
    <Helmet>
      <title>404 – Page Not Found</title>
    </Helmet>
  </Page>
)



// WEBPACK FOOTER //
// ./src/views/NoMatch.js